import { render, staticRenderFns } from "./IntervalReportByOrder.vue?vue&type=template&id=1a72535b"
import script from "./IntervalReportByOrder.vue?vue&type=script&lang=js"
export * from "./IntervalReportByOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports